import { useEffect, useState } from "react";
import api from "@/lib/api";
import CostHealthBar from "@/components/CostHealthBar";

const fmt = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

// A job's budget, committed, actual and remaining — shown on a purchase
// form as soon as a job is picked (Test Drive 2026-10-21).
export default function JobBudgetPanel({ jobId, testId = "job-budget-panel" }) {
  const [costs, setCosts] = useState(null);

  useEffect(() => {
    if (!jobId) { setCosts(null); return; }
    let live = true;
    api.get(`/contractor/jobs/${jobId}/costs`)
      .then((r) => { if (live) setCosts(r.data); })
      .catch(() => { if (live) setCosts(null); });
    return () => { live = false; };
  }, [jobId]);

  if (!costs) return null;
  const hasBudget = costs.budget_total != null;
  const cells = [
    ["Budget", hasBudget ? fmt(costs.budget_total) : "—", "budget"],
    ["Committed", fmt(costs.committed), "committed"],
    ["Actual", fmt(costs.actual), "actual"],
    ["Remaining", hasBudget ? fmt(costs.remaining) : "—", "remaining"],
  ];
  return (
    <div className="mt-3 border border-slate-200 rounded-xl p-4" data-testid={testId}>
      <h3 className="text-[12.5px] font-semibold text-slate-700">Job Budget</h3>
      <div className="mt-2.5 grid grid-cols-2 sm:grid-cols-4 gap-3 text-[12.5px]">
        {cells.map(([label, value, key]) => (
          <div key={key}>
            <div className="text-slate-400">{label}</div>
            <div className={`font-semibold mono ${key === "remaining" && hasBudget && costs.remaining < 0 ? "text-red-600" : ""}`} data-testid={`${testId}-${key}`}>{value}</div>
          </div>
        ))}
      </div>
      {costs.on_hold > 0 && (
        <div className="mt-2.5 text-[12px] text-amber-800 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2" data-testid={`${testId}-on-hold`}>
          {fmt(costs.on_hold)} in vendor invoices is waiting on budget — raise the job's budget to approve it.
        </div>
      )}
      {hasBudget ? (
        <div className="mt-3"><CostHealthBar spent={costs.spent} budgetTotal={costs.budget_total} health={costs.health} /></div>
      ) : (
        <div className="mt-2 text-[11.5px] text-slate-400">No budget set for this job.</div>
      )}
    </div>
  );
}
